import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import filterChildren from "../../../utils/Children/filterChildren";
import "./Table.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const TableHeaderColumn = _ref => {
  let {
    id = "",
    className = "",
    style = {},
    children = [],
    secondaryDataList = [],
    columnIndex = 0
  } = _ref;
  const tableHeaderColumnClass = cn("font-heavy-font text-xs tracking-wider px-3 py-2.5 uppercase text-left whitespace-no-wrap cursor-default", className);
  const newChildren = filterChildren(children);
  return /*#__PURE__*/_jsx("th", {
    id: id,
    className: tableHeaderColumnClass,
    style: style,
    children: newChildren
  });
};
TableHeaderColumn.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** children props for content inside */
  children: PropTypes.node,
  /** Column index passed from TableRow component */
  columnIndex: PropTypes.number.isRequired,
  /** Data (in columns) to hide passed from TableRow component */
  secondaryDataList: PropTypes.array
};
export default TableHeaderColumn;
//# sourceMappingURL=TableHeaderColumn.js.map